import { useCallback } from 'react';

declare global {
  interface Window {
    umami?: {
      track: (event: string | ((props: Record<string, unknown>) => Record<string, unknown>), data?: Record<string, unknown>) => void;
    };
  }
}

export function useUmami() {
  const trackEvent = useCallback((event: string, data?: Record<string, unknown>) => {
    if (window.umami) {
      window.umami.track(event, data);
    }
  }, []);

  const trackPageView = useCallback((url: string, title?: string) => {
    if (window.umami) {
      window.umami.track((props) => ({
        ...props,
        url,
        ...(title && { title }),
      }));
    }
  }, []);

  return { trackEvent, trackPageView };
}
